import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input } from 'antd';
import { debounce } from 'lodash';
import queryString from 'query-string';

import { ClientSections } from 'features/client/enums';
import { WorkersSectionsEnum } from 'features/worker/enums';
import { AssignmentSections } from 'features/assignment/enums';

type Props = {
  placeholder: string;
  className?: string;
  searchQuery?: string;
};

interface SearchQueryModel {
  section: ClientSections | WorkersSectionsEnum | AssignmentSections;
  query?: string;
}

export default function BaseSearch(props: Props) {
  const { searchQuery = '', placeholder } = props;
  const [query, setQuery] = useState(searchQuery);
  const navigate = useNavigate();
  const location = useLocation();
  const { section } = queryString.parse(location.search);

  useEffect(() => {
    setQuery(searchQuery);
  }, [searchQuery]);

  const onSearchCustomers = useCallback(
    (value: string) => {
      const queryData: SearchQueryModel = {
        section,
      };

      value && (queryData.query = value);

      navigate(`${location.pathname}?${queryString.stringify(queryData)}`, {
        replace: true,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [section],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(debounce(onSearchCustomers, 100), [
    onSearchCustomers,
  ]);

  const handleAutoCompleteChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const {
      target: { value },
    } = event;

    setQuery(value);
    debounceSearch(value);
  };

  return (
    <Input
      value={query}
      placeholder={placeholder}
      onChange={handleAutoCompleteChange}
    />
  );
}
